<app-header></app-header>
    <section class="content-box">
        <div class="tab-content" id="myTabContent">
            <!--  market Position -->
            <div class="tab-pane fade show active" id="market">
                <div class="deta-tebal-box">
                    <div class="heading-border-box">
                        <p></p>
                        <span>
                            <a  class="btn btn-danger p-0 px-3 m-0" [routerLink]="['/badlaorder']">
                                <i class="fas fa-arrow-left"></i> Back 
                            </a>    
                        </span>
                    </div>
                    <div class="setin-boxs d-flex justify-content-start ml-2">
                        <select class="form-control w-25" name="badlaType" [(ngModel)]="selectedBadla">
                            <option [value]="1">All</option>
                            <option *ngFor="let badlaIns of scriptFilter; let i = index;" value="{{badlaIns.badlRefId}}">{{badlaIns.reference}}</option>
                        </select>
                        <button type="button" class="btn but-boxa btn-primary" (click)="searchBadlaScript()">
                            Search
                        </button>
                        <h5 class="p-0 m-0 ml-2">Total PL : <span [ngClass]="overAllResult > 0 ? 'buy-class' : 'sell-class'">{{overAllResult}}</span></h5>
                        
                    </div>
                    <div class="respo-scroll">
                        <table class="default-table-style m-1 my-3" *ngFor="let badlaOrder of filterBadla; let i = index; let last = last;">
                            <!-- <thead>
                                <tr >
                                    <th class="text-center">Exchanges Name</th>
                                    <th class="text-center">Instrument Name</th>
                                    <th class="text-center">Buy Price</th>
                                    <th class="text-center">Sell Price</th>
                                    <th class="text-center">Net Change</th>
                                    <th class="text-center">High</th>
                                    <th class="text-center">Low</th>                                    
                                </tr>
                            </thead> -->
                            <tbody >
                                <tr>
                                    <td colspan="3">Badla Detail : {{badlaOrder['reference']}}
                                        [{{badlaOrder['duty']}}]
                                       
                                    </td>
                                    <td class="text-left">{{badlaOrder['updatedAt'] | date : 'dd/MM/yyyy hh:mm:ss a'}}</td>
                                </tr>
                                <tr>
                                    <td class="text-left col-md-3">{{badlaOrder['comexDetail'][0]['original_exchange']}} - {{badlaOrder['comexDetail'][0]['name']}} {{badlaOrder['comexDetail'][0]['expiry']}}</td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['comexType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['comexType'] | titlecase}} - {{badlaOrder['comexQty']}} - {{badlaOrder['comexPrice']}}</span>
                                    </td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['endComexType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['endComexType'] | titlecase}} - {{badlaOrder['comexQty']}} - {{badlaOrder['endComexPrice']}}</span> 
                                    </td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['comexResult'] > 0 ? 'buy-class' : 'sell-class' ">{{badlaOrder['comexResult']}}</span></td>
                                </tr>
                                <tr>
                                    <td class="text-left col-md-3">{{badlaOrder['mcxDetail'][0]['original_exchange']}} - {{badlaOrder['mcxDetail'][0]['name']}} {{badlaOrder['mcxDetail'][0]['expiry']}}
                                    </td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['mcxType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['mcxType'] | titlecase}} - {{badlaOrder['mcxQty']}} - {{badlaOrder['mcxPrice']}}</span></td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['endMcxType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['endMcxType'] | titlecase}} - {{badlaOrder['mcxQty']}} - {{badlaOrder['endMcxPrice']}}</span></td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['mcxResult'] > 0 ? 'buy-class' : 'sell-class' ">{{badlaOrder['mcxResult']}}</span></td> 
                                </tr>
                                <tr>
                                    <td class="text-left col-md-3">{{badlaOrder['dgcxDetail'][0]['original_exchange']}} to {{badlaOrder['dgcxDetail'][0]['name']}} {{badlaOrder['dgcxDetail'][0]['expiry']}}
                                    </td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['dgcxType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['dgcxType'] | titlecase}} - {{badlaOrder['dgcxQty']}} - {{badlaOrder['dgcxPrice']}}</span></td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['endDgcxType'] == 'buy' ? 'buy-class' : 'sell-class'" >{{badlaOrder['endDgcxType'] | titlecase}} -  {{badlaOrder['dgcxQty']}} - {{badlaOrder['endDgcxPrice']}}</span></td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['dgcxResult'] > 0 ? 'buy-class' : 'sell-class'">{{badlaOrder['dgcxResult']}}</span></td>
                                </tr>
                                <tr>
                                    <td class="text-center col-md-3">Created At : {{badlaOrder['createdAt'] | date : 'dd/MM/yyyy hh:mm:ss a'}} |  Updated At : {{badlaOrder['updatedAt'] | date : 'dd/MM/yyyy hh:mm:ss a'}}</td>
                                    <td class="text-center col-md-3"></td>
                                    <td class="text-center col-md-3"></td>
                                    <td class="text-center col-md-3"><span [ngClass]="badlaOrder['totalResult'] > 0 ? 'buy-class' : 'sell-class'">{{badlaOrder['totalResult']}}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                   

                </div>
            </div>
            <!-- badle settig -->
            <div class="tab-pane fade" id="badle">
               1 
            </div>
            <!--  settig Report -->
            <div class="tab-pane fade" id="settig">
                2
            </div>
            <!-- porfile Summary -->
            <div class="tab-pane fade" id="porfile">
              3 
            </div>
           


        </div>
       
    </section>
    
    <app-footer></app-footer>
    